<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex mb-2 justify-content-end align-items-start">
                    <!-- Title -->
                    <p class="flex-grow-1"><b>{{ $t('pointofinterest') }}</b> {{ poiType == "See" ? "What To Visit" : poiType == "Stay" ? "where To Stay" : "Where To Eat"}} </p>
                    <!-- Language dropdown -->
                    <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                </div>
                <!-- Form -->
                <div class="d-flex flex-wrap">
                     <!-- featuredImage -->
                    <div role="group" class="form-group col-12 col-lg-6">
                        <label class=""> {{ $t('featuredImageMandatory') }}</label>
                        <GalleryPicker class="gallery-picker" v-model="poi.featuredImage" :ratioWidth="4" :ratioHeight="3" v-bind:class="{ 'is-invalid': genericValidator(poi.featuredImage, attemptedSubmit) === false || errorValidator('FeaturedImage') === false }" :max="1"></GalleryPicker>
                    </div>
                    <!-- images -->
                    <div role="group" class="form-group col-12 col-lg-6">
                        <label class=""> {{ $t('imagesMandatory') }}</label>
                        <GalleryPicker class="gallery-picker" v-model="poi.images" :ratioWidth="4" :ratioHeight="3"  v-bind:class="{ 'is-invalid': genericValidator(poi.images, attemptedSubmit) === false || errorValidator('Images') === false }" :max="0"></GalleryPicker>
                    </div>
                    <!-- Titles -->
                    <div role="group" class="form-group col-12 col-lg-6">
                    <label class=""> {{ $t('titleMandatory') }}</label>
                        <CInput class="m-0" type="text" v-model="poi.titles[currentLanguage.key]" :invalid-feedback="errorOutput['Titles']" :is-valid="genericValidator(poi.titles, attemptedSubmit) && errorValidator('Titles')"></CInput>
                    </div>
                    <!-- TagLines -->
                    <div role="group" class="form-group col-12 col-lg-6">
                        <label class=""> {{ $t('tagLinesMandatory') }}</label>
                        <CInput class="m-0" type="text" v-model="poi.tagLines[currentLanguage.key]" :invalid-feedback="errorOutput['TagLines']" :is-valid="genericValidator(poi.tagLines, attemptedSubmit) && errorValidator('TagLines')"></CInput>
                    </div>
                    <!-- Category -->
                    <div role="group" class="form-group col-12 col-lg-6">
                        <label class=""> {{ $t('categoriesMandatory') }}</label>
                        <OptionsDropdown v-model="poi.categories" :options="categoriesOptions" :title="$t('categories')" :index="0" :is-valid="genericValidator(poi.categories, attemptedSubmit) && errorValidator('Categories')" :invalid-feedback="errorOutput['Categories']"></OptionsDropdown>
                    </div>
                    <!-- publishDate -->
                    <div role="group" class="form-group col-12 col-lg-6">
                        <label class=""> {{ $t('publishDate') }}</label>
                        <datepicker class="form-control" v-model="poi.publishDate" placeholder="DD-MM-YYYY" :disabled-dates="disabledDates"></datepicker>
                    </div>
                    <!-- Schedule -->
                    <div v-if="poiType !== 'Stay'" role="group" class="form-group col-12">
                        <label class=""> {{ $t('scheduleMandatory') }}</label>
                        <vue-editor v-model="poi.times[currentLanguage.key]" v-bind:class="{'is-invalid': genericValidator(poi.times, attemptedSubmit) == false || errorValidator('Times') }"></vue-editor>
                        <div v-if="errorOutput['Times']" class="invalid-feedback">{{errorOutput['Times']}}</div>
                    </div>
                    <!-- Address -->
                    <div role="group" class="form-group col-12">
                        <label class=""> {{ $t('addressMandatory') }}</label>
                        <vue-editor v-model="poi.address" v-bind:class="{'is-invalid': genericValidator(poi.address, attemptedSubmit) == false || errorValidator('Address') }"></vue-editor>
                        <div v-if="errorOutput['Address']" class="invalid-feedback">{{errorOutput['Address']}}</div>
                    </div>
                    <!-- Contact -->
                    <div role="group" class="form-group col-12 col-lg-6">
                    <label class=""> {{ $t('contactMandatory') }}</label>
                        <CInput class="m-0" type="text" v-model="poi.contact" :invalid-feedback="errorOutput['Contact']" :is-valid="genericValidator(poi.contact, attemptedSubmit) && errorValidator('Contact')"></CInput>
                    </div>
                    <!-- Latitude -->
                    <div role="group" class="form-group col-12 col-lg-6">
                    <label class=""> {{ $t('latitudeMandatory') }}</label>
                        <CInput class="m-0" type="number" v-model="poi.latitude" :invalid-feedback="errorOutput['Latitude']" :is-valid="genericValidator(poi.latitude, attemptedSubmit) && errorValidator('Latitude')"></CInput>
                    </div>
                    <!-- Longitude -->
                    <div role="group" class="form-group col-12 col-lg-6">
                    <label class=""> {{ $t('longitudeMandatory') }}</label>
                        <CInput class="m-0" type="number" v-model="poi.longitude" :invalid-feedback="errorOutput['Longitude']" :is-valid="genericValidator(poi.longitude, attemptedSubmit) && errorValidator('Longitude')"></CInput>
                    </div>
                    <!-- specialties -->
                    <div v-if="poiType == 'Eat'" role="group" class="form-group col-12 col-lg-6">
                    <label class=""> {{ $t('specialtiesMandatory') }}</label>
                        <CInput class="m-0" type="text" v-model="poi.specialties[currentLanguage.key]" :invalid-feedback="errorOutput['Specialties']" :is-valid="genericValidator(poi.specialties, attemptedSubmit) && errorValidator('Specialties')"></CInput>
                    </div>
                    <!-- Website -->
                    <div v-if="poiType !== 'See'" role="group" class="form-group col-12 col-lg-6">
                    <label class=""> {{ $t('websiteMandatory') }}</label>
                        <CInput class="m-0" type="text" v-model="poi.website" :invalid-feedback="errorOutput['Website']" :is-valid="genericValidator(poi.website, attemptedSubmit) && errorValidator('Website')"></CInput>
                    </div>
                    <!-- Rating -->
                    <div v-if="poiType == 'Stay'" role="group" class="form-group col-12 col-lg-6">
                    <label class=""> {{ $t('ratingMandatory') }}</label>
                        <CInput class="m-0" type="number" v-model="poi.rating" :invalid-feedback="errorOutput['Rating']" :is-valid="genericValidator(poi.rating, attemptedSubmit) && errorValidator('Rating')"></CInput>
                    </div>
                    <!-- MinPrice -->
                    <div v-if="poiType !== 'See'" role="group" class="form-group col-12 col-lg-6">
                    <label class=""> {{ $t('minPriceMandatory') }}</label>
                        <CInput class="m-0" type="number" v-model="poi.minPrice" :invalid-feedback="errorOutput['MinPrice']" :is-valid="genericValidator(poi.minPrice, attemptedSubmit) && errorValidator('MinPrice')"></CInput>
                    </div>
                    <!-- MaxPrice -->
                    <div v-if="poiType !== 'See'" role="group" class="form-group col-12 col-lg-6">
                    <label class=""> {{ $t('maxPriceMandatory') }}</label>
                        <CInput class="m-0" type="number" v-model="poi.maxPrice" :invalid-feedback="errorOutput['MaxPrice']" :is-valid="genericValidator(poi.maxPrice, attemptedSubmit) && errorValidator('MaxPrice')"></CInput>
                    </div>
                    <!-- files (not required) -->
                    <div role="group" class="form-group col-12 col-lg-6">
                        <FilesPicker v-model="poi.files" :title="$t('files')" v-bind:class="{ 'is-invalid': errorValidator('Files') === false }" :invalidFeedback="errorOutput['Files']"></FilesPicker>
                    </div>
                    <!-- Content -->
                    <div role="group" class="form-group col-12">
                        <label class=""> {{ $t('contentsMandatory') }}</label>
                        <vue-editor v-model="poi.contents[currentLanguage.key]" v-bind:class="{'is-invalid': genericValidator(poi.contents, attemptedSubmit) == false || errorValidator('Contents') }"></vue-editor>
                        <div v-if="errorOutput['Contents']" class="invalid-feedback">{{errorOutput['Contents']}}</div>
                    </div>
                </div>
                <!-- Action button + submitting -->  
                <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                <CButton v-else type="button" class="btn btn-primary align-self-end" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import router from '@/router/index';
import { deepClone } from "@/helpers/utils.js";
import { CONSTANTS } from '@/helpers/consts';
import { genericValidator, errorValidator } from "@/helpers/utils.js";
import Poi from "@/classes/Poi";
import { VueEditor } from "vue2-editor";
import LanguageDropdown from '@/controls/LanguageDropdown.vue'
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import FormLoading from '@/controls/FormLoading.vue'
import OptionsDropdown from '@/controls/OptionsDropdown.vue'
import InputGetList from "@/classes/InputGetList";
import Datepicker from 'vuejs-datepicker';
import GalleryPicker from '@/controls/GalleryPicker.vue'
import FilesPicker from '@/controls/FilesPicker.vue'
import { API_HELPER } from "@/helpers/api.js";

  export default {
        components: { LanguageDropdown, ConfirmationPopUp, FormLoading, VueEditor, OptionsDropdown, Datepicker, GalleryPicker, FilesPicker },
    props:{    
        basePoi:
        {
            type: Object,
            default: null,
        },
        baseName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
        poiType:{
            type: String,
            // default: 2
        }
    },
    data()
    {
        return {
            attemptedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            poi: new Poi({},{},{},{},{},[],[], this.poiType),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
            disabledDates: {
                to: new Date(new Date().setDate(new Date().getDate()-1))
            },
        }
    },
    mounted: function()
    {
        this.resetPoi();
        this.getPoiCategories();
    },
    computed:
    {
        ...mapState('pois', ['putPoiOutput']),
        ...mapState('pois', ['postPoiOutput']),
        ...mapState('categories', ['getCategoriesOutput']),
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = this.alertOutput && Array.isArray(this.alertOutput) ? this.alertOutput : [];

            // Validate multi language fields
            for (const [key, value] of Object.entries(this.poi.titles)) { if(!value) { result['Titles'] = this.$i18n.t("validateBothTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.poi.tagLines)) { if(!value) { result['TagLines'] = this.$i18n.t("validateBothTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.poi.contents)) { if(!value) { result['Contents'] = this.$i18n.t("validateBothTranslations"); break; }; }
            if(this.poiType == "See" || this.poiType == "Eat") for (const [key, value] of Object.entries(this.poi.times)) { if(!value) { result['Times'] = this.$i18n.t("validateBothTranslations"); break; }; }
            if(this.poiType == "Eat") for (const [key, value] of Object.entries(this.poi.specialties)) { if(!value) { result['specialties'] = this.$i18n.t("validateBothTranslations"); break; }; }

            return result;
        },
        name: function () {
            return this.basePoi || this.baseName ? (this.basePoi ? this.basePoi.name : this.baseName) : null;
        },
        categoriesInfo: function() {
            return this.getCategoriesOutput && this.getCategoriesOutput.data ? this.getCategoriesOutput.data : [];
        },
        categoriesOptions: function()
        {
            var result = [];

            if(this.categoriesInfo)
            {
                this.categoriesInfo.forEach(category => 
                {
                    result.push({key: category.id, label: category.name });
                });
            }

            return result;
        },
    },
    methods:{
        ...mapActions('categories', ['getCategories']),
        genericValidator,
        errorValidator,
        resetPoi(){
            if(!this.basePoi)
            {
                var titles = {}; var tagLines = {}; var contents = {}; var times = {}; var specialties = {}; 
                CONSTANTS.supportedLanguages.forEach(language => { titles[language.key] = ""; tagLines[language.key] = ""; contents[language.key] = ""; times[language.key] = ""; specialties[language.key] = "" });
                this.poi = new Poi(titles, tagLines, contents, times, specialties, [], [], this.poiType);
            }
            else
            {
                this.poi = deepClone(new Poi, this.basePoi);    
                // featuredImage
                this.poi.featuredImage = {url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.poi.featuredImagePath]), path: this.poi.featuredImagePath};
                
                // Images
                var images = [];
                this.poi.imagesPath.forEach(function(file)
                {
                    images.push({url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, file]), path: file});
                });
                this.poi.images = images;

                // File
                var files = [];
                this.poi.filesPath.forEach(function(file)
                {
                    files.push({path: file});
                });
                this.poi.files = files;

                // Categories
                this.poi.categories = this.poi.categories.map(x=> x.id);

            }
        },
        submitClicked(){
            this.attemptedSubmit = true;

            // when it is not a "eat" type, send the specialties with empty obj for the api to accept.
            if(this.poiType !== "Eat")
            {
                this.poi.specialties = {};
            }
            // Emit event
            if(this.poi.isValid())
            {
                this.submitting = true;
                this.$emit('submit-requested', this.poi);
            }
        },
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            router.push({name: 'Pois'});
        },
        onProcessTask: function(val)
        {
            if(val != null)
            {
                if(val)
                {
                    this.showConfirmationPopup = true;
                }

                this.submitting = false;
            }
        },
        getPoiCategories(){
            const itemsPerPage = 999;
            const currentPage = 1;
            const searchText = null;
            const sorter = 1; // ASC
            const propertyName = "name";

            var input = new InputGetList(itemsPerPage, currentPage, searchText, sorter, propertyName);
            input.type = 3; // type -> Poi

            this.getCategories(input);         
        },
    },
    watch:
    {
        putPoiOutput: function(val)
        {
            this.onProcessTask(val);
        },
        postPoiOutput: function(val)
        {
            this.onProcessTask(val);
        },
        basePoi: function()
        {
            this.resetPoi();
        },
        alertOutput: function()
        {
            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

@media only screen and (max-width: 767px) {
    .main-content {
        flex-direction: column;
    }
}

/deep/.quillWrapper.is-invalid .ql-snow.ql-toolbar,
/deep/.quillWrapper.is-invalid .ql-snow.ql-container
{
    border-color: #e55353;
}
>>>.vdp-datepicker input{
    border: none!important;
}
</style> 